import { useCurrentUser } from "./useCurrentUser";

export const useUserLanguage = () => {
  const currentUser = useCurrentUser();
  const { defaultLanguage: language } = currentUser ?? {};

  return language;
};
